import { Region } from '../../../../../../api/theHive/redeProto/types';
import { REGIONS } from '../../../../../../constants/redeProto';
import { SectionCard } from '../../components/SectionCard';
import { StateFeedback } from '../../components/StateFeedback';
import { classificationColor, protoColors } from '../../theme/tokens';
import { formatInt, formatPct } from '../../utils/format';
import {
  BarFill,
  BarTrack,
  FunnelWrap,
  Select,
  Stat,
  StatLabel,
  StatsRow,
  StatValue,
  StageHeader,
  StageRow,
  Toolbar,
} from './styles';
import useFunnel from './useFunnel';

export function Funnel(): JSX.Element {
  const {
    funnel,
    totalLeads,
    activeCount,
    rejectedCount,
    inactiveCount,
    ufOptions,
    region,
    setRegion,
    uf,
    setUf,
    loading,
    error,
  } = useFunnel();

  const maxCount = funnel.reduce((max, stage) => Math.max(max, stage.count), 0);
  const conversion = totalLeads === 0 ? 0 : (activeCount / totalLeads) * 100;

  return (
    <StateFeedback loading={loading} error={error} empty={false}>
      <Toolbar>
        <Select
          value={region}
          onChange={(event) => {
            setRegion(event.target.value as Region | 'all');
            setUf('all');
          }}
        >
          <option value="all">Todas as regiões</option>
          {REGIONS.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>

        <Select value={uf} onChange={(event) => setUf(event.target.value)}>
          <option value="all">Todas as UFs</option>
          {ufOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>
      </Toolbar>

      <StatsRow>
        <Stat>
          <StatLabel>Total no funil</StatLabel>
          <StatValue>{formatInt(totalLeads)}</StatValue>
        </Stat>
        <Stat>
          <StatLabel>Ativos</StatLabel>
          <StatValue color={classificationColor.healthy}>
            {formatInt(activeCount)}
          </StatValue>
        </Stat>
        <Stat>
          <StatLabel>Conversão (ativo/total)</StatLabel>
          <StatValue color={protoColors.purple}>
            {formatPct(conversion)}
          </StatValue>
        </Stat>
        <Stat>
          <StatLabel>Reprovados / Inativos</StatLabel>
          <StatValue color={classificationColor.critical}>
            {formatInt(rejectedCount + inactiveCount)}
          </StatValue>
        </Stat>
      </StatsRow>

      <SectionCard
        title="Funil de credenciamento"
        subtitle="Distribuição de candidatos por estágio"
      >
        <FunnelWrap>
          {funnel.map((stage) => (
            <StageRow key={stage.stage}>
              <StageHeader>
                <span>{stage.label}</span>
                <strong>{formatInt(stage.count)}</strong>
              </StageHeader>
              <BarTrack>
                <BarFill
                  sx={{
                    width: `${
                      maxCount === 0 ? 0 : (stage.count / maxCount) * 100
                    }%`,
                  }}
                />
              </BarTrack>
            </StageRow>
          ))}
        </FunnelWrap>
      </SectionCard>
    </StateFeedback>
  );
}
